import { Match, Show, Switch } from 'solid-js';
import { twJoin } from '@troon/tailwind-preset/merge';
import { Toast, Toaster } from '@ark-ui/solid/toast';
import { IconInfo } from '@troon/icons/info';
import { IconCircleCheck } from '@troon/icons/circle-check';
import { IconCircleWarning } from '@troon/icons/circle-warning';
import { IconCloseMd } from '@troon/icons/close-md';
import { Portal } from 'solid-js/web';
import { Button } from '../forms/button';
import { toaster } from './toast';

export function ToastRegion() {
	return (
		<Portal>
			<Toaster toaster={toaster}>
				{(toast) => (
					<Toast.Root
						role="status"
						class={twJoin(
							'opacity(--opacity) z-(--z-index) flex h-(--height) w-full min-w-xs translate-x-(--x) translate-y-(--y) scale-(--scale) items-start justify-stretch gap-2 rounded-lg p-4 pe-1 shadow-lg transition-all',
							toast().type === 'success' && 'bg-green-100 text-green-600',
							toast().type === 'error' && 'bg-red-100 text-red-600',
							(toast().type === 'info' || !toast().type) && 'bg-brand-100 text-brand-600',
						)}
					>
						<Switch fallback={<IconInfo class="size-6 shrink-0" title="Info" />}>
							<Match when={toast().type === 'success'}>
								<IconCircleCheck class="size-6 shrink-0" title="Success" />
							</Match>
							<Match when={toast().type === 'error'}>
								<IconCircleWarning class="size-6 shrink-0" title="Error" />
							</Match>
						</Switch>

						<div class="flex grow flex-col gap-1 text-sm">
							<Toast.Title class="font-semibold">
								{toast().title ?? title[toast().type ?? 'info'] ?? title.info}
							</Toast.Title>
							<Toast.Description>{toast().description}</Toast.Description>
							<Show when={toast().action}>
								{(action) => (
									<Toast.ActionTrigger
										asChild={(p) => <Button {...p()} appearance="tertiary-current" size="sm" class="size-fit grow-0" />}
									>
										{action().label}
									</Toast.ActionTrigger>
								)}
							</Show>
						</div>
						<Show when={toast().closable}>
							<Toast.CloseTrigger
								asChild={(p) => (
									<Button {...p()} appearance="transparent-current" size="sm" class="-mt-3 size-fit grow-0" />
								)}
							>
								<IconCloseMd />
							</Toast.CloseTrigger>
						</Show>
					</Toast.Root>
				)}
			</Toaster>
		</Portal>
	);
}

const title: Record<string, string> = {
	success: 'Success',
	error: 'Error',
	info: 'Information',
};
